// extracted by mini-css-extract-plugin
module.exports = {"countSummary":"OrderForm_countSummary__-eoCa"};